import './AllProductItem.css'
import { Link } from 'react-router-dom'
const AllProductItem = ({ _id, slug, images,imageType, title, price })=>{
    return(
        <>
        <Link to={`/product/${slug}/${_id}`}>
          <div className="Product__catalog">
            <div className=" product__image">
              {imageType === 'video' ? <video src={images} alt={title} playsInline muted loop autoPlay preload="metadata" loading="lazy"/> : <img src={images} alt={title} loading="lazy"/>}
            </div>
  
            <div className=" name__price">
              <h2 className='name__'>{title}</h2>
             
              <h3 className='price__'>NRP.{price}.00</h3>
             
            </div>
          </div>
        </Link>
      </>
    )
}
export default AllProductItem